<template>
  <div v-if="dataPermission?.includes('CNPS_DEVICE_ORDER_RETURN_VIEW')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách yêu cầu hoàn hàng</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          class="f12 font-medium btn btn-outline-secondary"
          @click="
            $router.push({ path: '/return-request/add' }) &&
              dataPermission.includes('CNPS_DEVICE_ORDER_RETURN_CREATE')
          "
        >
          <i class="bx bx-plus-circle"></i> Thêm mới
        </button>
        <!-- <button class="f12 font-medium btn btn-outline-secondary" @click="exportExcel()">
          <i class="bx bx-download"></i> Xuất excel
        </button> -->
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDateApprove()"
              v-model="dateRangeApprove"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian duyệt
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.billNumber"
              class="form-control f12 hc-37 text-search"
              placeholder="Mã yêu cầu"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.creatorId"
              :options="dataManager"
              placeholder="Người tạo"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.status"
              :options="dataStatus"
              placeholder="Trạng thái"
            ></Select2>
          </div>
          <div class="form-group form-group-action">
            <button
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
              @click="submitForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              type="button"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="removeForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div
              v-if="hasDefaultFilter"
              class="mb-2 d-inline-flex align-items-center"
              style="
                background-color: #fff3e0;
                padding: 6px 12px;
                border-radius: 4px;
                font-size: 13px;
              "
            >
              <i class="bx bx-info-circle mr-1" style="color: #f57c00"></i>
              <span style="color: #e65100">Đang lọc mặc định 3 ngày gần nhất</span>
              <button
                @click="removeDefaultFilter"
                type="button"
                class="ml-2 btn-close-filter"
                style="
                  background: none;
                  border: none;
                  cursor: pointer;
                  padding: 0 4px;
                  color: #e65100;
                  font-size: 16px;
                  line-height: 1;
                "
                title="Bỏ lọc"
              >
                ×
              </button>
            </div>

            Tổng phiếu hoàn hàng: {{ pagination.total }}
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="dataLeads"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(warehouseName)="data">
                {{ data.item.inventoryNameImport || '' }}
              </template>
              <template #cell(quantityImport)="data">
                <span class="text-muted">Tổng:</span> {{ data.item.quantityImport || '' }}
              </template>

              <template #cell(creatorApprover)="data">
                <div>
                  <p>
                    <span class="text-muted">Người tạo:</span>
                    <span v-if="data.item.userCreator">
                      {{ data.item.userCreator.name }}
                      <span v-if="data.item.userCreator.companyCode">
                        - {{ data.item.userCreator.companyCode }}</span
                      >
                      <span v-if="data.item.userCreator.typeSale">
                        - {{ data.item.userCreator.typeSale | transformData(listTypeSale) }}</span
                      >
                    </span>
                  </p>
                  <p v-if="data.item.personApprove">
                    <span class="text-muted">Người duyệt/Từ chối:</span>
                    {{ data.item.personApprove.name }}
                    <span v-if="data.item.personApprove.companyCode">
                      - {{ data.item.personApprove.companyCode }}</span
                    >
                    <span v-if="data.item.personApprove.typeSale">
                      - {{ data.item.personApprove.typeSale | transformData(listTypeSale) }}</span
                    >
                  </p>
                </div>
              </template>
              <template #cell(time)="data">
                <p>
                  <span class="text-muted">Tạo:</span>
                  {{ data.item.dateCreate | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
                <p v-if="data.item.timeApprove">
                  <span class="text-muted">Duyệt:</span>
                  {{ data.item.timeApprove | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </template>
              <template #cell(reasonReturn)="data">
                {{ data.item.reasonReturn | transformData(Config.reasonReturn) }}
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="[data.item.status || '']">
                  {{ data.item.status | transformData(dataStatus) }}
                </span>
                <div class="mt-2" v-if="data.item?.reasonReject">
                  <span class="text-muted">Lý do:</span> {{ data.item.reasonReject || '' }}
                </div>
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <button class="dropdown-item" @click="detailItem(data.item.id)">
                    <i class="bx bx-detail"></i><span>&nbsp;</span>Chi tiết
                  </button>
                  <button
                    v-if="canEdit(data.item.status, data.item.userCreator)"
                    class="dropdown-item"
                    @click="editItem(data.item.id)"
                  >
                    <i class="bx bx-pencil"></i><span>&nbsp;</span>Sửa
                  </button>
                  <button
                    v-if="canApprove(data.item.status, data.item.managerIdInventory)"
                    class="dropdown-item"
                    @click="approveItem(data.item)"
                  >
                    <i class="bx bx-check-circle"></i><span>&nbsp;</span>Duyệt
                  </button>
                  <button
                    v-if="canReject(data.item.status, data.item.managerIdInventory)"
                    class="dropdown-item"
                    @click="rejectItem(data.item)"
                  >
                    <i class="bx bx-x-circle"></i><span>&nbsp;</span>Từ chối
                  </button>
                  <button
                    v-if="
                      canCancel(
                        data.item.status,
                        data.item.userCreator,
                        data.item.managerIdInventory
                      )
                    "
                    class="dropdown-item"
                    @click="cancelItem(data.item)"
                  >
                    <i class="bx bxs-trash"></i><span>&nbsp;</span>Huỷ
                  </button>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>

    <b-modal id="modal-noti" centered v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          @click="close()"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { StaffService } from '@/services/staff.service'
  import { mapGetters } from 'vuex'
  import prepareQueryParamsMixin from '../../../mixins/prepareQueryParamsMixin'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import { DeviceService } from '../../../services/device.service'
  import mxItemAction from './mx-item-action.js'
  // import { getLastNDays } from '@/utils/util'
  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'billNumber', label: 'Mã yêu cầu' },
    { key: 'creatorApprover', label: 'Người tạo/ Người duyệt' },
    { key: 'quantityImport', label: 'Tổng số thiết bị', class: 'text-center' },
    { key: 'time', label: 'Thời gian' },
    { key: 'warehouseName', label: 'Tên kho hoàn' },
    { key: 'reasonReturn', label: 'Lý do hoàn hàng' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    mixins: [prepareQueryParamsMixin, mxItemAction],
    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        dataLeads: [],
        loading: false,
        tbLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        search: {
          limit: 20,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        localeData: Config.localeData,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        dateRangeApprove: {
          startDate: null,
          endDate: null,
        },
        dataManager: [],
        selected: [],
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
        warehouseData: [],
        dataStatus: [{ id: '0', text: 'Tất cả' }, ...Config.statusImportWarehouse],
        hasDefaultFilter: false,
        listTypeSale: [
          { id: 'REGION_DIRECTOR', text: 'Giám đốc vùng' },
          { id: 'SALE_DIRECTOR', text: 'Super Admin' },
          { id: 'SALE_MANAGER', text: 'Sale Manager' },
          { id: 'SALE_LEADER', text: 'Sale Leader' },
          { id: 'AFTER_SALE_LEADER', text: 'After Sale Leader' },
          { id: 'TELESALE_LEADER', text: 'Telesale Leader' },
          { id: 'SALE', text: 'Sale Man' },
          { id: 'SALE_ADMIN', text: 'Sale Admin' },
          { id: 'AFTER_SALE', text: 'After Sale' },
          { id: 'TELESALE', text: 'Telesale' },
          { id: 'KEY_ACCOUNT', text: 'Kế toán' },
        ],
      }
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    created() {
      this.fetchSuperiors()
      this.fetchWarehouse()
      this.fetchData()
    },
    mounted() {
      this.$root.$on('bv::modal::hide', bvEvent => {
        if (bvEvent.trigger === 'ok' && this.$refs.rejectValue) {
          if (!this.$refs.rejectValue.value.trim()) {
            this.showErr('Lý do nhập không được bỏ trống')
            bvEvent.preventDefault()
          } else if (
            this.$refs.rejectValue.value.trim().length < 2 ||
            this.$refs.rejectValue.value.trim().length > 255
          ) {
            this.showErr('Lý do nhập ký tự nhỏ nhất là 2 và lớn nhất là 255 ký tự')
            bvEvent.preventDefault()
          }
        }
      })
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          limit: this.search.limit,
          page: this.search.page,
        })
      },
      selectAll: {
        get: function () {
          return this.dataLeads ? this.selected.length === this.dataLeads.length : false
        },
        set: function (value) {
          var selected = []
          if (value) {
            this.dataLeads.forEach(function (item) {
              selected.push(item)
            })
          }
          this.selected = selected
        },
      },
    },
    filters: {
      // lấy ngày, giờ
      formatTime(ms) {
        return (
          new Date(ms).getHours() +
          ':' +
          new Date(ms).getMinutes() +
          ', ' +
          new Date(ms).getDate() +
          '/' +
          (new Date(ms).getMonth() + 1) +
          '/' +
          new Date(ms).getFullYear()
        )
      },
      transformData(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },
    methods: {
      async fetchSuperiors() {
        try {
          const { data } = await StaffService.superiors()
          const dat = data.map(e => {
            return { id: e.id, text: e.name }
          })
          this.dataManager = [{ id: '0', text: 'Tất cả' }, ...dat]
        } catch (e) {
          console.error(e)
        }
      },
      async fetchWarehouse() {
        const response = await DeviceService.getListSearchWarehouse()
        const data = response.data.map(({ id, name }) => {
          return { id, text: name }
        })
        this.warehouseData = [{ id: '0', text: 'Tất cả' }, ...data]
      },
      transformDate() {
        this.search.dateFrom = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.dateTo = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
      },
      transformDateApprove() {
        this.search.timeApproveFrom = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.timeApproveTo = moment(this.dateRange.endDate)
          .endOf('day')
          .add(7, 'hours')
          .valueOf()
      },
      async submitForm(event) {
        event.preventDefault()
        this.search.page = 1
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.dateRange = { startDate: null, endDate: null }
        this.dateRangeApprove = { startDate: null, endDate: null }
        this.selected = []
        this.hasDefaultFilter = false
        await this.fetchData()
      },

      removeDefaultFilter() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.dateRange = { startDate: null, endDate: null }
        this.dateRangeApprove = { startDate: null, endDate: null }
        this.selected = []
        this.hasDefaultFilter = false
        this.fetchData()
      },
      async fetchData() {
        try {
          this.tbLoading = true
          if (this.search.inventoryIdImport === '0') {
            delete this.search.inventoryIdImport
          }
          if (this.search.creatorId === '0') delete this.search.creatorId
          if (this.search.status === '0') delete this.search.status

          const response = await DeviceService.getListReturnRequest(this.search)
          if (response.code === 1000) {
            this.dataLeads = response.data.orders || []
            this.pagination.total = response.data.count ? response.data.count : 0
          } else {
            this.showErr(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.tbLoading = false
        }
      },
      async exportExcel() {
        try {
          this.loading = true
          const req = { ...this.search }
          delete req.page
          delete req.limit
          await DeviceService.exportExcelReturnRequest(req)
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      showErr(message) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
        this.msgNoti = message
      },
      showSuccess(message) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-success2.svg')
        this.msgNoti = message
      },
    },
  }
</script>

<style>
  .time-placeholder,
  .text-search::placeholder {
    color: #999 !important;
  }

  .card .card-header .dropdown .dropdown-toggle {
    font-size: 16px !important;
    margin-top: -12px !important;
  }
</style>
